<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <h1 class="news1">Updating Records to Digital Guide</h1>
      <br />
      <div class="flex md12 sm12 xs12">
        <form @submit="onSubmit" enctype="multipart/form-data">
          <div class="row">
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Common Name
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <input
                  type="text"
                  class="form-control"
                  required
                  aria-required="”true”"
                  aria-describedby="emailHelp"
                  placeholder=" Common Name"
                  v-model="commonName"
                />
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Scientific Name
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <input
                  type="text"
                  class="form-control"
                  required
                  aria-describedby="emailHelp"
                  placeholder="Scientific Name "
                  v-model="scientificName"
                />
              </div>
              <p
                v-if="!searchStatus"
                style="color: red; font-size: 14px !important"
              >
                {{ showMsg }}
              </p>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Type
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <label
                  for="exampleInputEmail1"
                  style="text-align: left !important"
                ></label>
                <b-form-select
                  class="pt-2 pb-2 form-control"
                  style="width: 100% !important"
                  required
                  v-model="typeId"
                >
                  <option value selected disabled hidden>Types</option>

                  <option
                    class="text-capitalize"
                    v-for="type in types"
                    :value="type._id"
                    :key="type._id"
                  >
                    {{ type.tname }}
                  </option>
                </b-form-select>
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Traded Parts
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <input
                  type="text"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Traded Parts "
                  v-model="tradedParts"
                />
              </div>
            </div>
            <div class="flex md4 py-0">
              <span style="padding-top: 10px" class="formstyle1">
                Classification
              </span>
              <div class="form-group pt-2">
                <label
                  for="exampleInputEmail1"
                  style="text-align: left !important"
                ></label>
                <b-form-select
                  class="pt-2 pb-2"
                  style="width: 100% !important"
                  required
                  v-model="classificationId"
                >
                  <option
                    class="text-capitalize"
                    value
                    selected
                    disabled
                    hidden
                  >
                    Classification
                  </option>
                  <option v-for="cls in classi" :value="cls._id" :key="cls._id">
                    {{ cls.cname }}
                  </option>
                </b-form-select>
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                CITES
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <label
                  for="exampleInputEmail1"
                  style="text-align: left !important"
                ></label>
                <b-form-select
                  class="pt-2 pb-2"
                  style="width: 100% !important"
                  required
                  v-model="citesId"
                >
                  <option value selected disabled hidden>CITES</option>

                  <option
                    class="text-capitalize"
                    v-for="cit in CITES"
                    :value="cit._id"
                    :key="cit._id"
                  >
                    {{ cit.name }}
                  </option>
                </b-form-select>
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Wild Life Protection Act,1972(WLPA)
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <label
                  for="exampleInputEmail1"
                  style="text-align: left !important"
                ></label>
                <b-form-select
                  class="pt-2 pb-2"
                  style="width: 100% !important"
                  required
                  v-model="wlpaId"
                >
                  <option value selected disabled hidden>WLPA</option>

                  <option
                    class="text-capitalize"
                    v-for="wlp in WLPA"
                    :value="wlp._id"
                    :key="wlp._id"
                  >
                    {{ wlp.name }}
                  </option>
                </b-form-select>
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                IUCN
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <label
                  for="exampleInputEmail1"
                  style="text-align: left !important"
                ></label>
                <b-form-select
                  class="pt-2 pb-2"
                  style="width: 100% !important"
                  v-model="conservationStatusId"
                >
                  <option value selected disabled hidden>IUCN</option>

                  <option
                    class="text-capitalize"
                    v-for="st in stat"
                    :value="st._id"
                    :key="st._id"
                  >
                    {{ st.csname }}
                  </option>
                </b-form-select>
              </div>
            </div>
            <div class="flex md4 py-0">
              <span class="formstyle1">
                Distribution
                <sup>*</sup>
              </span>
              <div class="form-group pt-2">
                <input
                  type="text"
                  class="form-control"
                  aria-required="”true”"
                  aria-describedby="emailHelp"
                  placeholder="Distribution"
                  v-model="distribution"
                />
              </div>
            </div>
          </div>

          <div class="form-group pt-2">
            <label for="exampleFormControlTextarea1">Identification </label>
            <vue-editor
              class="textField2 pt-1"
              v-model="identification"
            ></vue-editor>
          </div>
          <!-- <div class="form-group pt-2">
            <label for="exampleFormControlTextarea1">More Details </label>
            <vue-editor
              class="textField2 pt-1"
              v-model="moreDetails"
            ></vue-editor>
          </div> -->
          <div align="right">
            <button type="submit" class="btn btn-success">NEXT</button>
          </div>
        </form>
      </div>
    </va-card>
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import VueElementLoading from "vue-element-loading";

export default {
  components: {
    VueEditor,
    VueElementLoading,
  },
  props: ["id"],
  data() {
    return {
      visible: false,
      cls: "",
      wl: "",
      stat: [],
      occu: [],
      wlpaId1: "",
      commonName: "",
      scientificName: "",
      classificationId: "",
      wlpaId: "",
      citesId: "",
      tradedParts: "",
      conservationStatusId: "",
      CITES: [],
      stat: [],
      classi: [],
      WLPA: [],
      types: [],
      typeId: null,
      // moreDetails: null,
      identification: null,
      distribution: null,
      showMsg: null,
      searchStatus: true,

      // characteristics: [
      //   {
      //     charas: null,
      //   },
      // ],
      // inputs: [
      //   {
      //     name: '',
      //   },
      // ],
    };
  },
  beforeMount() {
    this.typeview();

    this.wlpaview();
    this.statview();
    this.citesview();
    this.classview();
  },
  mounted: function () {
    // this.newsGet()
    this.getView();
  },
  watch: {
    scientificName: function () {
      this.search();
    },
  },
  methods: {
    add(index) {
      this.characteristics.push({
        charas: null,
      });
    },
    remove(index) {
      this.characteristics.splic2e(index, 1);
    },

    addchar() {},
    statview() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/conservation/all/list",
      })
        .then((response) => {
          this.stat = response.data.data;
          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          console.log(err);
        });
    },
    classview() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/classification/all/list",
      })
        .then((response) => {
          this.classi = response.data.data;

          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          console.log(err);
        });
    },
    typeview() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/DGtype/all/list",
      })
        .then((response) => {
          this.types = response.data.data;
          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          console.log(err);
        });
    },
    citesview() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/cites/all/list",
      })
        .then((response) => {
          this.CITES = response.data.data;

          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          console.log(err);
        });
    },
    wlpaview() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/wlpa/all/list",
      })
        .then((response) => {
          this.WLPA = response.data.data;

          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          console.log(err);
        });
    },

    getView() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/digitalguide/view/" + this.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.data = response.data.data;
            this.commonName = response.data.data.commonName;
            this.scientificName = response.data.data.scientificName;
            this.classificationId = response.data.data.classificationId._id;
            this.citesId = response.data.data.citesId._id;
            this.wlpaId = response.data.data.wlpaId._id;
            this.typeId = response.data.data.typeId._id;
            this.tradedParts = response.data.data.tradedParts;
            // this.moreDetails = response.data.data.moreDetails;
            this.distribution = response.data.data.distribution;
            this.identification = response.data.data.identification;

            this.conservationStatusId =
              response.data.data.conservationStatusId._id;

            // this.family = response.data.data.family
            // this.description = response.data.data.description
            // this.characteristics = response.data.data.characteristics
            // var temp = []

            // for (var i = 0; i < this.characteristics.length; i++) {
            //   var ch = {
            //     charas: this.characteristics[i],
            //   }
            //   temp.push(ch)
            // }
            // this.characteristics = temp
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var add = {};

      add["commonName"] = this.commonName;
      add["scientificName"] = this.scientificName;
      add["classificationId"] = this.classificationId;
      add["citesId"] = this.citesId;
      add["wlpaId"] = this.wlpaId;
      add["tradedParts"] = this.tradedParts;
      add["conservationStatusId"] = this.conservationStatusId;
      add["typeId"] = this.typeId;
      // add["moreDetails"] = this.moreDetails;
      add["identification"] = this.identification;
      add["distribution"] = this.distribution;
      // ...................................
      //    var chars = [];
      // for (var i = 0; i < this.characteristics.length; i++) {
      //   chars.push(this.characteristics[i].charas);
      // }
      // add["characteristics"] = chars;
      //   add["description"] = this.description;
      // add["family"] = this.family;
      // ...................................

      evt.preventDefault();
      this.visible = true;
      axios({
        method: "post",
        url: "/digitalguide/edit/" + this.id,
        data: add,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.visible = false;
            this.$router.push("/editdigi/" + this.id);
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "error" }
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.visible = true;
      var data1 = {};
      data1["id"] = this.id;
      data1["scientificName"] = this.scientificName;

      axios({
        method: "POST",
        url: "/check/DG/scientificName",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.searchStatus = response.data.status;
          if (this.searchStatus) {
            this.visible = false;
          } else {
            this.visible = false;
            this.showMsg = response.data.msg;
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },
  },
};
</script>
<style>
#editor1,
#editor2 {
  height: 350px;
}
.news1 {
  font-size: 24px;
  color: #002c85;
}
.news2 {
  font-size: 20px;
  color: #002c85;
  padding-bottom: 20px;
}
</style>
